//抽奖函数
export function luckDraw(that, opts) {
  return new Promise(function(resolve, reject) {
    //默认配置设置
    let options = {
      header: "",
      params: "",
      retry: { //重刷机制
        open: false, //是否打开重刷
        count: 1, //重试的次数,默认是1次
        current_count: 0, //当前是第几次重试
      }
    }
    //如果有传入参数
    if (opts) {
      //设置传入参数的值
      Object.keys(opts).forEach(k => {
        if (opts[k] !== "" && opts[k] !== undefined && opts[k] !== "undefined") {
          //判断是否是对象
          if(Object.prototype.toString.call(opts[k]) === '[Object Object]'){
            Object.keys(opts[k]).forEach(key => {
              options[k][key] = opts[k][key];
            })
          }else{
            options[k] = opts[k];
          }
        }
      })
    }
    let obj = {
      code: jm.getCode(),
      provice_name: "",
      city_name: "",
      area_name: "",
      address: "",
      longitude: "",
      dimension: "",
      // phone_model:jm.phone_info.phone_name
    }

    let objH = {
      'Content-Type': 'application/json-patch+json'
    }

    if (jm.gps) { //添加gps数据
      for (let k in jm.gps) {
        if (jm.gps[k] && jm.gps[k] != 'undefined') {
          obj[k] = jm.gps[k];
        }
      }
    }
    if (options.params) { //添加自定义参数
      for (let k in options.params) {
        if (options.params[k] && options.params[k] != 'undefined') {
          obj[k] = options.params[k];
        }
      }
    }
    if (options.header) { //添加header信息
      for (let k in options.header) {
        if (options.header[k] && options.header[k] != 'undefined') {
          objH[k] = options.header[k];
        }
      }
    }
	// 关闭位置信息的提示框
    if (!jm.gps.provice_name && false) {//判断是否需要收集地理位置信息
      jm.wxGetLocation(true);
      jm.checkGps(function() {
        if (jm.gps.provice_name) {
          return resolve({
            isVaildDraw: true,
            res: null,
            opts:options
          })
        } else {
          jm.showTip()
        }
      })
      reject()
    }
    
    //如果获取到地址位置定位之后,隐藏掉地理位置的弹框
    that.$store.commit('updataGpsLoading', false);

    //调用抽奖接口
    that.$axios.post(jm.site.THIRTY + '/api/v1/hongqi/game/lottery', obj, {
      headers: objH
    }).then(res => {
      //如果接口返回错误的情况下,分情况处理
      if (!res.success) {
        //需要图片校验抽奖
        if (res.code == 10000) {
          that.getImageCode();
          that.$store.dispatch('updataSenVaildShow', true);
          // return false;
          reject()
        }
        //需要完成人机校验后抽奖
        if (res.code == 10001) {
          var obj = JSON.parse(res.ai_extra_validation);
          initGeetest({
            // 以下配置参数来自服务端 SDK
            gt: obj.gt,
            challenge: obj.challenge,
            offline: !obj.success,
            new_captcha: true,
            product: 'bind'
          }, function(captchaObj) {
            // 这里可以调用验证实例 captchaObj 的实例方法
            captchaObj.onReady(function() {
              captchaObj.verify();
            }).onSuccess(function() {
              let result = captchaObj.getValidate();
              if (!result) {
                jm.showMsg("请完成校验");
                // return false;
                reject()
              }
              let h = {
                geetest_challenge: result.geetest_challenge,
                geetest_validate: result.geetest_validate,
                geetest_seccode: result.geetest_seccode
              }
              if (options.header) { //添加header信息
                options.header.geetest_challenge=result.geetest_challenge;
                options.header.geetest_validate=result.geetest_validate;
                options.header.geetest_seccode=result.geetest_seccode;
              }
              return resolve({
                isVaildDraw: true,
                res: null,
                opts: options
              })
              //your code
            }).onError(function() {
              //your code
            })
          })
          // return false;
          reject()
        }
        //如果设置了重刷机制,并且当前重刷次数小于总的重刷次数时,继续请求接口
        if (options.retry.open && options.retry.count > options.retry.current_count) {
          options.retry.current_count+=1;//当前重刷次数+1
          that.$store.commit('updataLoading', true);//loading需再次显示
          let timer=1100;
          //如果是场景码抽奖时,接口未设置1s请求多次,系统繁忙的限制,因此下一次请求接口的时间可以调低一点
          if(obj&&obj.code&&obj.code.indexOf("SEN")>-1){
            timer=10;
          }
          setTimeout(function(){
            return resolve({
              isVaildDraw: true,
              res: null,
              opts: options
            })
          },timer);
          // return false;
          reject()
        }
      }
      //返回抽奖结果
      return resolve({
        isVaildDraw: false,
        res: res
      })
    }).catch(res => {
      reject(res);
    })
  }).then(({
    isVaildDraw,
    res,
    opts
  }) => {
    return isVaildDraw ? luckDraw(that, opts) : Promise.resolve(res);
  })
}
//获取中奖列表
export function getWinGoods(that, header, params) {
  return new Promise(function(resolve, reject) {
    params = params ? params : {};
    header = header ? header : {}
    that.$axios.get(jm.site.ACTJEXTRA + '/api/v1/act/win/goods', {
      params: params,
      headers: header
    }).then(res => {
      resolve(res);
    }).catch(res => {
      reject(res)
    })
  })
}
//export {
//	getWinGoods as getWinGoods, lunkDraw as lunkDraw
//}



//////////////////
// WEBPACK FOOTER
// ./static/js/common.js
// module id = null
// module chunks = 